'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                transform: 'translate(0 1)',
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('path', {
                d: 'M71.064 59.44c2.685-4.856 4.22-10.23 4.22-16.177 0-18.69-15.104-33.84-33.734-33.84-18.632 0-33.735 15.15-33.735 33.84 0 5.946 1.534 11.32 4.22 16.177h59.029z',
                fill: '#F7F7F8'
            }),
            _react2.default.createElement('path', {
                fill: '#FFCF3F',
                d: 'M40.767 5.21h1.565V0h-1.565zM31.384 6.656l-1.345-5.032 1.512-.407 1.345 5.032zM22.694 10.489l-2.597-4.512 1.355-.785 2.597 4.512zM15.289 16.447l-3.673-3.684 1.107-1.11 3.673 3.684zM9.673 24.125L5.176 21.52l.782-1.36 4.498 2.606zM6.23 33l-5.016-1.35.404-1.515 5.018 1.348zM81.48 53.227l-5.017-1.349.405-1.516 5.017 1.348zM0 42.466h5.194v-1.57H0zM77.904 42.466h5.194v-1.57h-5.194zM1.619 53.227l-.406-1.517 5.018-1.348.404 1.516zM76.868 33l-.405-1.517 5.017-1.348.405 1.516zM73.425 24.125l-.782-1.36 4.497-2.605.783 1.36zM67.81 16.447l-1.107-1.11 3.673-3.684 1.106 1.11zM60.405 10.489l-1.356-.785 2.597-4.512 1.356.785zM51.714 6.656l-1.512-.407 1.345-5.032 1.512.407z'
            }),
            _react2.default.createElement('ellipse', {
                fill: '#A7F2EB',
                cx: '17.346',
                cy: '35.4',
                rx: '1.794',
                ry: '1.8'
            }),
            _react2.default.createElement('ellipse', {
                fill: '#A7F2EB',
                cx: '66.395',
                cy: '35.4',
                rx: '1.794',
                ry: '1.8'
            }),
            _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement(
                    'g',
                    {
                        fill: '#3F5060'
                    },
                    _react2.default.createElement('path', {
                        d: 'M62.058 58.2h-1.682V32.788c0-1.868 1.509-3.388 3.364-3.388 1.856 0 3.365 1.52 3.365 3.388v.847h-1.682v-.847a1.69 1.69 0 0 0-1.683-1.694 1.69 1.69 0 0 0-1.682 1.694V58.2z'
                    }),
                    _react2.default.createElement('path', {
                        d: 'M66.264 34.482a.844.844 0 0 0-.841.847c0 .468.376.847.84.847.465 0 .842-.379.842-.847a.844.844 0 0 0-.841-.847m0 3.389a2.535 2.535 0 0 1-2.524-2.542 2.535 2.535 0 0 1 2.524-2.54 2.535 2.535 0 0 1 2.523 2.54 2.535 2.535 0 0 1-2.523 2.542M23.365 58.2h-1.682V32.788A1.69 1.69 0 0 0 20 31.094a1.69 1.69 0 0 0-1.683 1.694v.847h-1.682v-.847c0-1.868 1.51-3.388 3.365-3.388 1.855 0 3.364 1.52 3.364 3.388V58.2z'
                    }),
                    _react2.default.createElement('path', {
                        d: 'M17.477 34.482a.844.844 0 0 0-.841.847c0 .468.377.847.841.847.465 0 .841-.379.841-.847a.844.844 0 0 0-.84-.847m0 3.389a2.535 2.535 0 0 1-2.524-2.542 2.535 2.535 0 0 1 2.523-2.54 2.535 2.535 0 0 1 2.524 2.54 2.535 2.535 0 0 1-2.524 2.542'
                    })
                ),
                _react2.default.createElement('path', {
                    fill: '#FFF',
                    d: 'M26.331 58.056V46.5l-.804-.806.804-2.688V22.312h10.717l.268-10.48 2.68-2.688 3.214-.269 2.411 1.075.804 2.15v10.212l10.985.27-.268 20.155.804 1.075.268 2.42-1.072.268v11.825z'
                }),
                _react2.default.createElement('path', {
                    fill: '#FFEDBB',
                    d: 'M32.226 26.075h3.215v6.45h-3.215zM40.799 26.075h3.215v6.45h-3.215zM39.191 46.8l5.627.281.268 11.244h-6.43zM40.263 15.325h3.215v6.45h-3.215zM48.3 26.075h3.216v6.45H48.3zM32.226 36.825h3.215v6.45h-3.215zM39.727 36.825h3.215v6.45h-3.215zM48.3 36.825h3.216v6.45H48.3z'
                }),
                _react2.default.createElement('path', {
                    d: 'M59.553 23.119H45.889v-9.675a4.03 4.03 0 0 0-4.019-4.032 4.03 4.03 0 0 0-4.019 4.032v9.675H24.187l.014-1.757 1.594-8.797v-2.346h11.46A5.619 5.619 0 0 1 41.87 7.8a5.62 5.62 0 0 1 4.616 2.419h11.46v2.33l1.607 7.345v3.225z',
                    fill: '#3F5060'
                }),
                _react2.default.createElement('path', {
                    d: 'M25.809 21.506h10.435v-8.062c0-.56.082-1.102.234-1.613h-9.076l-.012.95-1.581 8.725zM47.497 21.506h10.448v-1.524l-1.607-7.344v-.807h-9.075c.152.511.234 1.053.234 1.613v8.062z',
                    fill: '#00D8C8'
                }),
                _react2.default.createElement('path', {
                    d: 'M36.244 32.794h-1.607V27.15a.805.805 0 0 0-.804-.806.805.805 0 0 0-.804.806v5.644h-1.607V27.15a2.418 2.418 0 0 1 2.41-2.419 2.418 2.418 0 0 1 2.412 2.419v5.644z',
                    fill: '#3F5060'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M32.225 30.375h3.215v-1.613h-3.215zM30.618 33.6h6.43v-1.613h-6.43zM44.282 32.794h-1.608V27.15a.805.805 0 0 0-.803-.806.805.805 0 0 0-.804.806v5.644h-1.608V27.15a2.418 2.418 0 0 1 2.412-2.419 2.418 2.418 0 0 1 2.41 2.419v5.644z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M40.263 30.375h3.215v-1.613h-3.215zM38.655 33.6h6.43v-1.613h-6.43z'
                }),
                _react2.default.createElement('path', {
                    d: 'M52.32 32.794h-1.608V27.15a.805.805 0 0 0-.804-.806.805.805 0 0 0-.804.806v5.644h-1.607V27.15a2.418 2.418 0 0 1 2.411-2.419 2.418 2.418 0 0 1 2.411 2.419v5.644z',
                    fill: '#555'
                }),
                _react2.default.createElement('path', {
                    fill: '#555',
                    d: 'M48.3 30.375h3.216v-1.613H48.3zM46.693 33.6h6.43v-1.613h-6.43z'
                }),
                _react2.default.createElement('path', {
                    d: 'M52.32 32.794h-1.608V27.15a.805.805 0 0 0-.804-.806.805.805 0 0 0-.804.806v5.644h-1.607V27.15a2.418 2.418 0 0 1 2.411-2.419 2.418 2.418 0 0 1 2.411 2.419v5.644z',
                    fill: '#3F5060'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M48.3 30.375h3.216v-1.613H48.3zM46.693 33.6h6.43v-1.613h-6.43zM36.244 43.275h-1.607v-5.644a.805.805 0 0 0-.804-.806.805.805 0 0 0-.804.806v5.644h-1.607v-5.644a2.418 2.418 0 0 1 2.41-2.419 2.418 2.418 0 0 1 2.412 2.42v5.643z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M32.225 40.856h3.215v-1.612h-3.215zM30.618 44.081h6.43V42.47h-6.43zM44.282 43.275h-1.608v-5.644a.805.805 0 0 0-.803-.806.805.805 0 0 0-.804.806v5.644h-1.608v-5.644a2.418 2.418 0 0 1 2.412-2.419 2.418 2.418 0 0 1 2.41 2.42v5.643z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M40.263 40.856h3.215v-1.612h-3.215zM38.655 44.081h6.43V42.47h-6.43z'
                }),
                _react2.default.createElement('path', {
                    d: 'M52.32 43.275h-1.608v-5.644a.805.805 0 0 0-.804-.806.805.805 0 0 0-.804.806v5.644h-1.607v-5.644a2.418 2.418 0 0 1 2.411-2.419 2.418 2.418 0 0 1 2.411 2.42v5.643z',
                    fill: '#555'
                }),
                _react2.default.createElement('path', {
                    fill: '#555',
                    d: 'M48.3 40.856h3.216v-1.612H48.3zM46.693 44.081h6.43V42.47h-6.43z'
                }),
                _react2.default.createElement('path', {
                    d: 'M52.32 43.275h-1.608v-5.644a.805.805 0 0 0-.804-.806.805.805 0 0 0-.804.806v5.644h-1.607v-5.644a2.418 2.418 0 0 1 2.411-2.419 2.418 2.418 0 0 1 2.411 2.42v5.643z',
                    fill: '#3F5060'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M48.3 40.856h3.216v-1.612H48.3zM46.693 44.081h6.43V42.47h-6.43zM45.89 58.594h-1.608v-8.869a2.418 2.418 0 0 0-2.411-2.419 2.418 2.418 0 0 0-2.412 2.419v8.869h-1.607v-8.869a4.03 4.03 0 0 1 4.019-4.031 4.03 4.03 0 0 1 4.018 4.031v8.869z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M38.655 51.337h6.43v-1.612h-6.43z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M41.067 58.594h1.607V50.53h-1.607zM30.618 58.594h1.607V48.112h-1.607z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M31.422 56.175h7.233v-1.612h-7.233zM51.516 58.594h1.607V48.112h-1.607z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M45.086 56.175h7.233v-1.612h-7.233zM27.403 58.594h-1.608V47.306h-.804v-3.559l.804-.806V22.312h1.608V43.61l-.804.806v1.279h.804z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M26.599 44.081h2.411V42.47H26.6zM26.599 47.306h11.253v-1.612H26.599zM57.946 58.594h-1.608v-12.9h.804v-1.279l-.804-.806V22.312h1.608v20.63l.804.805v3.56h-.804z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M54.73 44.081h2.412V42.47h-2.411zM45.89 47.306h11.252v-1.612H45.889zM16.15 59.4h51.441v-1.613h-51.44zM41.067 12.637h1.607v-1.612h-1.607zM41.067 21.506h1.607V16.67a.805.805 0 0 0-.803-.806.805.805 0 0 0-.804.806v4.837zm3.215 1.613h-4.823v-6.45a2.418 2.418 0 0 1 2.412-2.419 2.418 2.418 0 0 1 2.41 2.419v6.45z'
                }),
                _react2.default.createElement('path', {
                    fill: '#3F5060',
                    d: 'M40.263 19.894h3.215V18.28h-3.215z'
                })
            )
        )
    );
};

DefaultIcon.defaultProps = {
    width: '83',
    height: '60',
    viewBox: '0 0 83 60',
    xmlns: 'http://www.w3.org/2000/svg'
};

var ProfileIcon = function (_React$Component) {
    _inherits(ProfileIcon, _React$Component);

    function ProfileIcon() {
        _classCallCheck(this, ProfileIcon);

        return _possibleConstructorReturn(this, (ProfileIcon.__proto__ || Object.getPrototypeOf(ProfileIcon)).apply(this, arguments));
    }

    _createClass(ProfileIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { fill: this.props.hover || this.props.active ? _colors.Colors.calmWhite : _colors.Colors.claimBlack, width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return ProfileIcon;
}(_react2.default.Component);

exports.default = ProfileIcon;